const MainURL = 'https://ministermore.co.kr';

export default MainURL;